import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/BlocksRendererCustom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/Carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/Form/PopForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Skeleton/ImageSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSkeleton"] */ "/app/src/app/_components/Skeleton/ImageSkeleton2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_custom/item/components/02-Brief.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_custom/item/components/image-switcher/ImageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_custom/item/components/Loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_custom/item/components/StyleList/FAQList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Slide.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section1.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section2.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section3.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section4.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section5.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section6.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section7.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section8.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section9.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section10.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Section11.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/Sample.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/PopForm.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_custom/item/styles/RelatedCustoms.module.css");
